<template>
  <v-card :color="color" class="white--text" v-if="userCS && userCS.id">
    <v-container grid-list-md>
      <v-layout class="row wrap align-center justify-end row fill-height">
        <v-flex xs12 sm12 md6>
          <v-card flat class="white--text">
            <v-card-title primary-title>
              <div>
                <span class="headline">{{ userCS.name }}</span>
                <v-btn
                  icon
                  ripple
                  @click="
                    editDialog = true;
                    editTarget = 'name';
                  "
                  v-if="permissions.edit_customer"
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      ripple
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        editCredentials = true;
                        editTarget = 'cpf';
                      "
                      v-if="permissions.edit_cpf_cnpj"
                    >
                      <v-icon color="grey lighten-1" class="mr-3"
                        >mdi-account-convert</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Editar CPF/CNPJ do usuário</span>
                </v-tooltip>
                <br v-if="userCS.person_type === 'pj'" />
                <v-icon v-if="userCS.person_type === 'pj'">business</v-icon
                >{{ userCS.person_type === "pj" ? userCS.company_name : "" }}
                <v-btn
                  v-if="
                    userCS.person_type === 'pj' && permissions.edit_customer
                  "
                  icon
                  ripple
                  @click="
                    editDialog = true;
                    editTarget = 'company_name';
                  "
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
                <span v-if="userCS.partner"
                  ><br />Parceria:
                  <span class="title">{{ userCS.partner.name }}</span></span
                >
              </div>
              <div>
                <v-spacer></v-spacer>
                <div v-if="userCS.forced_canceling">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small dark round color="black" v-on="on">
                        <strong>Cancelamento Forçado</strong>
                      </v-btn>
                    </template>
                    <span v-if="userCS.abonar_faturas" class="font-weight-bold"
                      >Faturas abonadas</span
                    >
                    <span v-else class="font-weight-bold"
                      >Faturas não abonadas</span
                    >
                    <span
                      ><br />Motivo: {{ userCS.reasonForcedDescription }}</span
                    >
                  </v-tooltip>
                </div>
                <div v-if="userCS.judicial_process">
                  <v-btn small dark round color="black">
                    <strong>Em processo judicial</strong>
                  </v-btn>
                </div>
                <div v-else>
                  <v-tooltip
                    bottom
                    v-if="
                      userCS.status === 'canceling' ||
                      userCS.status === 'canceled'
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        dark
                        round
                        :color="userCS.status | statusColor"
                        v-on="on"
                      >
                        <strong>{{ userCS.status | formatUCStatus }}</strong>
                      </v-btn>
                    </template>
                    <span
                      v-if="
                        userCS.status_reason || userCS.status_reason_description
                      "
                      ><br />
                      <div v-if="userCS.canceled_at">
                        <strong>Cancelado em: </strong
                        >{{ userCS.canceled_at | formatarDate }} <br /><br />
                      </div>
                      <strong>Motivo: </strong
                      >{{ userCS.status_reason | formatStatusReason
                      }}<br /><br />
                      <strong>Descrição: </strong
                      >{{ userCS.status_reason_description }}
                    </span>
                    <span v-else>Motivo: {{ userCS.bot_status }}</span>
                  </v-tooltip>
                  <v-btn
                    small
                    dark
                    round
                    :color="userCS.status | statusColor"
                    v-else
                  >
                    <strong>{{ userCS.status | formatUCStatus }}</strong>
                  </v-btn>
                  <v-btn
                    v-if="userCS.payment_rating"
                    small
                    dark
                    round
                    color="purple"
                  >
                    <strong> rating: {{ userCS.payment_rating.rating }}</strong>
                  </v-btn>
                </div>
                <v-btn
                  small
                  round
                  color="blue"
                  v-if="userCS.account_balance && userCS.account_balance > 0"
                >
                  Bônus {{ userCS.account_balance | formatCurrency }}
                </v-btn>
                <v-btn small round color="blue" v-if="userCS.total_savings">
                  Economizou {{ userCS.total_savings | formatCurrency }}
                </v-btn>
                <v-btn
                  small
                  round
                  :color="hasNegativationActive ? 'red' : 'purple'"
                  v-if="negativations.length > 0"
                  @click="dialog_hasNegativation = true"
                >
                  {{
                    hasNegativationActive
                      ? "Negativado"
                      : "Negativação removida"
                  }}
                </v-btn>
                <v-btn small round color="orange" v-if="overdue">
                  Pendência(s) Financeiras
                </v-btn>
                <v-btn
                  small
                  round
                  color="blue darken-3"
                  v-if="userCS.third_party"
                >
                  Cobrança {{ userCS.third_party }}
                </v-btn>
                <v-btn
                  small
                  round
                  color="green lighten-1"
                  v-if="userCS.limpa_nome === true"
                  @click="openLimpaNomeDialog(userCS.id)"
                >
                  Limpa Nome =)</v-btn
                >
                <v-btn
                  small
                  round
                  color="green lighten-1"
                  v-else-if="userCS.limpa_nome === false"
                  class="custom-cursor"
                >
                  Limpa Nome Removido</v-btn
                >
                <v-btn small round color="purple" v-if="underAnalysis"
                  >Em Análise</v-btn
                >
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md2 style="z-index: 5">
          <v-btn small round color="purple" @click="showReferral(userCS.email)"
            ><v-icon v-if="userCS.referral_invites > 0" dark left
              >emoji_events</v-icon
            >Indicou {{ userCS.referral_invites || 0 }} amigos</v-btn
          >
          <!-- <v-card color="darken-2" class="black--text">
            <v-card>
              <div>
                <span> amigos que indicou fechou com a Juntos</span>
                <div class="headline">Ganhou {{ userCS.referral_reward }} ao indicar esses amigos</div>
                <span>Ainda possui {{ userCS.referral_balance }} de saldo a receber</span>
              </div>
            </v-card>
          </v-card> -->
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-layout class="align-center justify-end row fill-height">
            <v-card flat>
              <v-layout align-center justify-end row fill-height wrap>
                <v-btn-toggle dark :class="'pa-4 ' + color">
                  <v-tooltip bottom v-if="permissions.forced_cancellation">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        @click.prevent.stop="showForceCanceling"
                        v-if="
                          userCS.status &&
                          userCS.status.toUpperCase() === 'CANCELING' &&
                          permissions.forced_cancellation
                        "
                      >
                        <v-icon v-on="on" color="red lighten-3"
                          >person_add_disabled</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Forçar Cancelamento</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-btn flat @click.prevent.stop="showChangeEmail">
                        <v-icon v-on="on">mail</v-icon>
                      </v-btn>
                    </template>
                    <span>Trocar e-mail</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-btn flat @click.prevent.stop="showResetPassword">
                        <v-icon v-on="on">vpn_key</v-icon>
                      </v-btn>
                    </template>
                    <span>Resetar Senha</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        :href="
                          'https://www.huggy.app/panel/contacts/' +
                          userCS.huggy_id
                        "
                        target="_blank"
                      >
                        <v-icon v-on="on">local_activity</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir Atendimento no Huggy</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        :href="
                          'https://super.juntosenergia.com.br/membros/faturas/' +
                          userCS.customer_id
                        "
                        target="_blank"
                      >
                        <v-icon v-on="on">manage_accounts</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir Portal de Negociação</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="isAdmin || isQualityManagement">
                    <template v-slot:activator="{ on }">
                      <v-btn flat @click="goToMember(userCS.customer_id)">
                        <v-icon v-on="on">app_registration</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Membro e Unidade Consumidora</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="isAdmin">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="
                          userCS.status &&
                          userCS.status.toUpperCase() !== 'CANCELING' &&
                          userCS.status.toUpperCase() !== 'INATIVO' &&
                          userCS.status.toUpperCase() !== 'CANCELED'
                        "
                        flat
                        @click.prevent.stop="multa()"
                      >
                        <v-icon v-on="on">person_remove</v-icon>
                      </v-btn>
                    </template>
                    <span
                      v-if="
                        userCS.status &&
                        userCS.status.toUpperCase() !== 'CANCELING' &&
                        userCS.status.toUpperCase() !== 'INATIVO' &&
                        userCS.status.toUpperCase() !== 'CANCELED'
                      "
                      >Cancelar Usuário</span
                    >
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="
                          userCS.status &&
                          userCS.status.toUpperCase() === 'CANCELING'
                        "
                        flat
                        @click.prevent.stop="reactivateUserDialog = true"
                      >
                        <v-icon v-on="on">person_add</v-icon>
                      </v-btn>
                    </template>
                    <span
                      v-if="
                        userCS.status &&
                        userCS.status.toUpperCase() === 'CANCELING'
                      "
                      >Reativar Usuário</span
                    >
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="
                          userCS.status &&
                          (userCS.status.toUpperCase() === 'INATIVO' ||
                            userCS.status.toUpperCase() === 'CANCELED')
                        "
                        flat
                        @click.prevent.stop="consumerUnitDialog = true"
                      >
                        <v-icon v-on="on">person_add</v-icon>
                      </v-btn>
                    </template>
                    <span
                      v-if="
                        userCS.status &&
                        (userCS.status.toUpperCase() === 'INATIVO' ||
                          userCS.status.toUpperCase() === 'CANCELED')
                      "
                      >Reativar Usuário</span
                    >
                  </v-tooltip>

                  <v-tooltip v-if="isAdmin || isCustomerCareLeader" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn flat @click.prevent.stop="analysisDialog = true">
                        <v-icon v-on="on">{{ analysisData.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ analysisData.tooltip }}</span>
                  </v-tooltip>
                </v-btn-toggle>
                <v-spacer />
                <v-spacer /><ConsumerUnits v-if="consumerUnits.length" />
              </v-layout>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog_forceCanceling" max-width="500px">
      <v-card dark>
        <v-form ref="userForcedCancel">
          <v-card-title class="headline red white--text" primary-title>
            <span v-if="consumerUnits.length" class="headline color-danger"
              >Atenção: Tem certeza que deseja forçar o cancelamento do usuário
              e todas as suas unidades consumidoras?</span
            >
            <span v-else class="headline color-danger"
              >Atenção: Tem certeza que deseja forçar o cancelamento do
              usuário?</span
            >
          </v-card-title>
          <v-card-text>
            Ao forçar o cancelamento as faturas que seriam cobradas do membro no
            futuro serão abonadas.
          </v-card-text>
          <v-card-text>
            <v-btn round outline v-for="uc in consumerUnits" :key="uc.id">{{
              uc.id
            }}</v-btn>
            <v-checkbox
              v-model="freeOldBillings"
              label="Abonar todas as faturas abertas já existentes"
            ></v-checkbox>
          </v-card-text>
          <v-card-text>
            <v-textarea
              box
              name="description_forced_canceled"
              v-model="reasonForcedDescription"
              placeholder="Escreva a descrição do motivo do cancelamento forçado..."
              :rules="[
                (v) =>
                  !!v ||
                  'Por favor, informe uma descrição do motivo de cancelamento.',
              ]"
              required
            ></v-textarea>
          </v-card-text>

          <v-card-actions class="align">
            <v-spacer></v-spacer>
            <v-btn color="white" flat @click="dialog_forceCanceling = false"
              >NÃO</v-btn
            >
            <v-btn
              color="red"
              @click="forceCancelingUser(userCS)"
              :disabled="!permissions.forced_cancellation"
              >SIM</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_changeEmail" max-width="500px" persistent>
      <v-form v-model="valid">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Tem certeza que deseja trocar o email desse membro?</span
            >
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Email Atual"
              prepend-icon="unsubscribe"
              :value="userCS.email"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="email"
              label="Novo Email"
              prepend-icon="mark_email_read"
              :rules="emailRules"
              type="email"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="align">
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_changeEmail = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="primary"
              flat
              @click.prevent="changeEmail(userCS, email)"
              :disabled="!valid || loading_changeEmail"
              :loading="loading_changeEmail"
              >Alterar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_referral" max-width="500px" persistent>
      <v-form v-model="valid">
        <v-card>
          <v-card-title>
            <span class="headline">Indicações</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Quantidade de indicações que entraram para a Juntos"
              prepend-icon="person_add"
              prefix="#"
              :value="userCS.referral_invites"
              disabled
            ></v-text-field>
            <v-text-field
              label="Total ganho com indicações"
              prepend-icon="emoji_events"
              prefix="R$"
              :value="userCS.referral_reward"
              disabled
            ></v-text-field>
            <v-text-field
              label="Valor a receber nas próximas faturas"
              prepend-icon="savings"
              prefix="R$"
              :value="userCS.referral_balance"
              disabled
            ></v-text-field>
          </v-card-text>
          <v-container v-if="referrals && referrals.length > 0">
            <v-card>
              <v-card-title>
                Detalhe
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search_referral"
                  append-icon="search"
                  label="Busca"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers_referral"
                :items="referrals"
                :search="search_referral"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.created_at | formatarDate }}</td>
                  <td class="text-xs-right">
                    {{ props.item.referral_indicated }}
                  </td>
                  <td class="text-xs-right">
                    R$ {{ props.item.referral_value_indicator }}
                  </td>
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" color="error" icon="warning">
                    Sua busca por "{{ search }}" náo encontrou resultados.
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-container>
          <v-card-actions class="align">
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_referral = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_resetPassword" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline color-danger"
            >Atenção: Essa ação irá enviar email para o membro alterar a
            senha</span
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Email Atual"
            prepend-icon="mark_email_read"
            :value="userCS.email"
            disabled
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog_resetPassword = false"
            >Cancelar</v-btn
          >
          <v-btn color="primary" flat @click="resetPassword(userCS)"
            >Enviar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reactivateUserDialog" max-width="500px">
      <v-card dark>
        <v-card-title class="headline red white--text" primary-title>
          <span v-if="consumerUnits.length" class="headline color-danger"
            >Atenção: Tem certeza que deseja reativar o usuário e todas as suas
            unidades consumidoras?</span
          >
          <span v-else class="headline color-danger"
            >Atenção: Tem certeza que deseja reativar o usuário?</span
          >
        </v-card-title>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="reactivateUserDialog = false"
            >NÃO</v-btn
          >
          <v-btn color="green" @click="reactivateUser(userCS)">SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cancellingUser" max-width="500px">
      <v-card dark>
        <v-card-title class="headline red white--text" primary-title>
          <span v-if="consumerUnits.length" class="headline color-danger"
            >Atenção: Tem certeza que deseja cancelar o usuário e todas as suas
            unidades consumidoras?</span
          >
          <span v-else class="headline color-danger"
            >Atenção: Tem certeza que deseja cancelar o usuário?</span
          >
        </v-card-title>
        <v-card-actions class="align">
          <v-card-title v-if="hasFine == true">
            <v-card-text>
              <span>
                OBS: O cancelamento desse usuário acarretará em
                <span class="font-weight-bold"
                  >R$ {{ valorMulta.toFixed(2).replace(".", ",") }}</span
                >
                em multa(s) referente(s) a(s) unidade(s) consumidora(s):
                {{ consumer_units_fine.toString() }}</span
              >
            </v-card-text>
          </v-card-title>
        </v-card-actions>
        <v-card-text>
          <v-btn round outline v-for="uc in consumerUnits" :key="uc.id">{{
            uc.id
          }}</v-btn>
          <v-form ref="userStatus">
            <v-container grid-list-md>
              <v-checkbox
                v-if="canFreeFine && showBottomAboned"
                v-model="checkbox_free_fine"
                color="blue"
              >
                <template v-slot:label v-if="showBottomAboned">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="blue--text font-weight-bold"
                        >Abonar multa de cancelamento</span
                      >
                    </template>
                    <span
                      >Abonar multa, Apenas disponível para mudança de endereço
                      e para o gestor</span
                    >
                  </v-tooltip>
                </template>
              </v-checkbox>
              <v-select
                prepend-inner-icon="flag"
                :items="filteredReasons"
                v-model="reason"
                item-text="text"
                item-value="value"
                placeholder="Motivo"
                :rules="[(v) => !!v || 'Motivo é obrigatório!']"
                required
              ></v-select>
              <v-text-field
                v-model.number="serviceId"
                placeholder="ID de atendimento"
                :rules="[
                  (v) => !!v || 'Por favor, informe o ID de atendimento.',
                  (v) => /^[0-9]*$/.test(v) || 'Apenas números são permitidos.',
                ]"
                required
              ></v-text-field>
              <v-textarea
                box
                name="description"
                v-model="reasonDescription"
                placeholder="Escreva a descrição do motivo do cancelamento..."
                :rules="[
                  (v) =>
                    !!v ||
                    'Por favor, informe uma descrição do motivo de cancelamento.',
                ]"
                required
              ></v-textarea>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="dialog_cancellingUser = false"
            >NÃO</v-btn
          >
          <v-btn color="red" @click="cancellingUser()">SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_activateUser" max-width="500px">
      <v-card color="teal" dark>
        <v-card-title>
          <span v-if="consumerUnits.length" class="headline color-danger"
            >Atenção: Tem certeza que deseja ativar o usuário e todas as suas
            unidades consumidoras?</span
          >
          <span v-else class="headline color-danger"
            >Atenção: Tem certeza que deseja ativar o usuário?</span
          >
        </v-card-title>
        <v-card-text v-if="consumerUnits.length">
          <v-btn round v-for="uc in consumerUnits" :key="uc.id">{{
            uc.id
          }}</v-btn>
        </v-card-text>
        <v-card-text v-else>
          <span>Esse usuário não possui unidade consumidora cadastrada</span>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="dialog_activateUser = false"
            >NÃO</v-btn
          >
          <v-btn
            color="white"
            flat
            @click="activateUser(userCS)"
            :disabled="loadingChange"
            :loading="loadingChange"
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_hasNegativation" max-width="600px" persistent>
      <v-card dark>
        <v-card-title
          :class="`headline ${
            hasNegativationActive ? 'red' : 'purple'
          } white--text`"
          primary-title
        >
          <span v-if="consumerUnits.length" class="headline color-danger"
            >O membro possui negativação
            {{ hasNegativationActive ? "ATIVA" : "REMOVIDA" }}</span
          >
          <span v-else class="headline color-danger"></span>
        </v-card-title>
        <v-card-text>
          O membro possui debitos que foram enviados para negativação junto ao
          Serasa. Abaixo a lista de débitos negativados:
        </v-card-text>
        <v-card-text>
          <v-list two-line>
            <v-list-tile
              v-for="negativation in negativations"
              :key="negativation.id"
            >
              <v-list-tile-content avatar>
                <v-list-tile-title>
                  UC: {{ negativation.consumer_unit }}
                  <!-- - Status: {{negativation.status | formatStatusNegativation}} -->
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Competência: {{ negativation.competence }} - Data de Venc.
                  {{ negativation.due_date | formatarDate }} -
                  <span class="font-weight-bold"
                    >R$ {{ negativation.total | formatCurrency }}</span
                  >
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  small
                  round
                  :color="
                    negativation.status_billing | formatStatusBillingColor
                  "
                >
                  {{ negativation.status_billing | formatTransactionStatus }}
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions class="align">
          <v-btn color="white" outline @click="dialog_hasNegativation = false"
            >Fechar</v-btn
          >
          <v-spacer v-if="hasNegativationActive"></v-spacer>
          <!-- {{negativations}} -->
          <v-btn
            v-if="hasNegativationActive"
            color="red"
            @click="dialog_removeNegativation = true"
            :disabled="
              hasNegativationNotPaid && !permissions.remove_negativations
            "
            >Remover Negativação</v-btn
          >
          <v-dialog
            v-model="dialog_removeNegativation"
            hide-overlay
            max-width="450"
          >
            <v-card>
              <v-card-title class="headline red lighten-2 white--text">
                <v-icon color="white darken-2 pr-2" large
                  >mdi-alert-circle-outline</v-icon
                >
                <span class="ml-2">Confirmação de cancelamento</span>
              </v-card-title>
              <v-spacer></v-spacer>
              <v-card-text>
                Tem certeza que deseja retirada o cliente da negativação?
                <span class="font-weight-bold"
                  >Essa ação é permanentemente!</span
                >
                <br /><br />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="grey darken-1"
                  @click="dialog_removeNegativation = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  :loading="loadingChange"
                  @click="removeNegativations(NegativationActiveList)"
                >
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar informação do membro</span>
        </v-card-title>
        <v-card-text>
          <v-form :ref="editTarget" v-if="editTarget == 'name'">
            <v-text-field
              label="Nome"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Nome"
              prepend-icon="star"
              name="editValue"
              counter
              :rules="[
                (v) => !!v || 'Por favor, informe o nome.',
                (v) => v.length >= 10 || 'O nome deve ser completo!',
              ]"
              required
              v-model="editValue"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'company_name'">
            <v-text-field
              label="Razão Social"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Nova Razão Social"
              prepend-icon="star"
              name="editValue"
              counter
              :rules="[
                (v) => !!v || 'Por favor, informe a Razão social.',
                (v) => v.length >= 10 || 'A Razão Social deve ser completa!',
              ]"
              required
              v-model="editValue"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="
              editDialog = false;
              editValue = '';
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeUserData"
            :disabled="!permissions.edit_customer"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editCredentials" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar informação do membro</span>
        </v-card-title>
        <v-card-text>
          <v-form :ref="editTarget" v-if="userCS.person_type === 'pj'">
            <v-text-field
              v-if="editTarget === 'cnpj'"
              label="CNPJ"
              prepend-icon="star_border"
              :value="userCS.cpf"
              :mask="'##.###.###/####-##'"
              disabled
            ></v-text-field>
            <v-text-field
              v-if="editTarget === 'cnpj'"
              label="Novo CNPJ"
              prepend-icon="star"
              v-model="editValue"
              :mask="'##.###.###/####-##'"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-else>
            <v-text-field
              v-if="editTarget === 'cpf'"
              label="CPF"
              prepend-icon="star_border"
              :value="userCS.cpf"
              :mask="'###.###.###-##'"
              disabled
            ></v-text-field>
            <v-text-field
              v-if="editTarget === 'cpf'"
              label="Novo CPF"
              prepend-icon="star"
              v-model="editValue"
              :mask="'###.###.###-##'"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="
              editCredentials = false;
              editValue = '';
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeCredentials"
            :disabled="!permissions.edit_cpf_cnpj"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="consumerUnitDialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          Selecione as Unidade(s) Consumidora(s) que deseja reativar
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            flat
            color="error"
            @click="consumerUnitDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list three-line>
            <v-list-tile
              v-for="(uc, idx) in consumerUnits"
              :key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_checkbox"
                  :value="idx"
                  :color="colors_uc[idx]"
                ></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  uc.address.address
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :loading="loading_qualification"
            :disabled="
              ucs_checkbox?.length == 0 ||
              !ucs_checkbox ||
              loading_qualification
            "
            @click="ucs_selected(userCS)"
            >Qualificar</v-btn
          >
        </v-card-actions>
        <v-spacer></v-spacer>
        <v-flex
          xs12
          sm12
          md12
          v-if="qualifications && qualifications.length > 0"
        >
          <v-list three-line>
            <template v-for="(qualification, idx) in qualifications">
              <qualifying-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'pending'"
              />
              <not-qualified-card
                :key="idx"
                :qualification="qualification"
                v-if="
                  qualification.status === 'bill_not_found' ||
                  qualification.status === 'error'
                "
              />
              <disqualified-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'disqualified'"
              />
              <qualified-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'qualified'"
              />
            </template>
          </v-list>
        </v-flex>
        <v-card v-if="qualifications && qualifications.length > 0">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              :loading="loading_qualification"
              :disabled="loading_qualification"
              @click="finishQualificationProcess(userCS)"
              >Reativar</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-if="finish_ucs && finish_ucs.length > 0">
          <v-card-text>
            <v-list three-line>
              <v-list-tile
                v-for="uc in finish_ucs"
                :key="uc.installation_number"
              >
                <v-list-tile-action>
                  <v-icon
                    v-if="uc.icon === 'mdi-alert-circle'"
                    color="red lighten-1"
                    >{{ uc.icon }}</v-icon
                  >
                  <v-icon v-else color="success">{{ uc.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    uc.installation_number
                  }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    uc.message
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="analysisDialog" max-width="500px">
      <v-card dark>
        <v-card-title class="headline red white--text" primary-title>
          <span class="headline color-danger">{{ analysisData.title }}</span>
        </v-card-title>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="analysisDialog = false">NÃO</v-btn>
          <v-btn
            color="green"
            @click="
              underAnalysis ? removeFromAnalysis(userCS) : putInAnalysis(userCS)
            "
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="limpaNome.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red lighten-2 white--text">
          <v-icon color="white darken-2 pr-2" large
            >mdi-alert-circle-outline</v-icon
          >
          <span class="ml-2">Remoção do Limpa Nome</span>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Deseja remover de fato este usuário do limpa nome? Certifique-se que
          todas as faturas do usuário não estejam com a tag do limpa nome
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red darken-1" @click="limpaNome.dialog = false">
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="removeLimpaNome(limpaNome.userId)"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" outline @click="snackbar.value = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-card>
</template>
<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { firebaseAuth } from "../../firebase/firebaseAuth";
import { hasSomeUserGroupMixin } from "../../mixin/hasSomeUserGroupMixin";
import { hasPermissionMixin } from "../../mixin/permissionsMixin";
import { getFine } from "../../services/billing";
import { removeNegativation } from "../../services/negativation";
import {
  finishQualification,
  initQualification,
} from "../../services/qualification";
import { saveAnalytics } from "../../services/save_analytics";
import {
  cancelUser,
  changeEmail,
  getObligations,
  reactivateCustomer,
  updateUser,
  updateUserCore,
} from "../../services/users";
import DisqualifiedCard from "../sales/qualification/DisqualifiedCard.vue";
import NotQualifiedCard from "../sales/qualification/NotQualifiedCard.vue";
import QualifiedCard from "../sales/qualification/QualifiedCard.vue";
import QualifyingCard from "../sales/qualification/QualifyingCard.vue";
import ConsumerUnits from "./ConsumerUnits";

export default {
  components: {
    ConsumerUnits,
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
  },
  mixins: [hasSomeUserGroupMixin, hasPermissionMixin],
  computed: {
    ...mapGetters("cs", [
      "userCSError",
      "userCSNotFound",
      "NegativationActiveList",
      "hasNegativationActive",
      "hasNegativationNotPaid",
      "hasLimpaNome",
    ]),
    ...mapGetters("qualification", ["qualifications"]),
    ...mapState("cs", [
      "userCS",
      "consumerUnits",
      "negativations",
      "overdue",
      "referrals",
      "limpa_nome_removed",
    ]),
    ...mapState(["user", "permissions"]),
    color() {
      if (this.userCS.judicial_process) return "purple darken-2";
      else if (this.userCS.status === "canceling") return "orange darken-4";
      else if (this.userCS.status === "canceled") return "red darken-4";
      else return "blue-grey darken-2";
    },
    underAnalysis() {
      return this.userCS.underAnalysis ?? false;
    },
    analysisData() {
      const data = {
        icon: this.underAnalysis ? "search_off" : "person_search",
        tooltip: this.underAnalysis
          ? "Retirar membro da análise"
          : "Colocar membro em análise",
        title: this.underAnalysis
          ? "Atenção: Tem certeza que deseja retirar o usuário da análise?"
          : "Atenção: Tem certeza que deseja colocar o usuário em análise?",
      };
      return data;
    },
    limpa_nome() {
      return this.userCS.limpa_nome ?? false;
    },

    filteredReasons() {
      if (this.isQualityManagement) {
        return this.reasons;
      }

      return this.reasons.filter(
        (reason) =>
          !["wrong_sale", "sale_analysis", "legal_request"].includes(
            reason.value,
          ),
      );
    },
    showBottomAboned() {
      return this.consumerUnits.some((unit) => {
        if (unit.plan.contract_time === 0) {
          return false;
        }
        const dateContractSigned = dayjs(
          new Date(unit.contract_signed_at.seconds * 1000),
        );

        const currentDate = dayjs();

        const diffMonth = currentDate.diff(dateContractSigned, "month");

        return diffMonth < unit.plan.contract_time;
      });
    },
    isQualityManagement: function () {
      if (this.user && this.user.group) {
        return this.user.group.includes("quality_management");
      }
      return false;
    },
  },
  watch: {
    reason() {
      if (this.reason === "gave_up") this.checkbox_free_fine = true;
    },
  },
  data() {
    return {
      agent_email: null,
      toggle_exclusive: false,
      toggle_none: null,
      editDialog: false,
      editCredentials: false,
      editTarget: "",
      editValue: "",
      valorMulta: "",
      consumer_units_fine: [],
      hasFine: false,
      loadingChange: false,
      loading_qualification: false,
      dialog_forceCanceling: false,
      dialog_changeEmail: false,
      dialog_resetPassword: false,
      dialog_cancellingUser: false,
      reactivateUserDialog: false,
      consumerUnitDialog: false,
      dialog_activateUser: false,
      dialog_hasNegativation: false,
      dialog_removeNegativation: false,
      dialog_referral: false,
      loading_changeEmail: false,
      email: "",
      qualification_ids: [],
      ucs_checkbox: [],
      colors_uc: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      finish_ucs: [],
      negs: [],
      // hasNegativationActive: [],
      // hasNegativationNotPaid: [],
      // hasNegativation: false,
      emailRules: [
        (v) => !!v || "Por favor, informe o email",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail precisa ser válido",
      ],
      valid: false,
      reasons: [
        { text: "Mudou de concessionária", value: "new_utility_company" },
        { text: "Instalou painel próprio", value: "own_panel" },
        { text: "Fornecimento Duplicado", value: "duplicated_supply" },
        { text: "Mudou o consumo abaixo do mínimo", value: "low_consumption" },
        { text: "Mudou para baixa renda", value: "low_income" },
        {
          text: "Impossibilidade de alteração da data de pagamento;",
          value: "cant_change_payment_date",
        },
        { text: "Desconto insuficiente", value: "insufficient_discount" },
        { text: "Inadimplência", value: "non_payment" },
        {
          text: "Cancelado na concessionária",
          value: "utility_company_canceled",
        },
        { text: "Mudou de endereço", value: "address_changed" },
        { text: "Venda incorreta", value: "wrong_sale" },
        { text: "Contrato Rejeitado", value: "rejected_contract" },
        // { text: "Recusa / Não tem interesse", value: "not_interested" },
        { text: "Análise de Adesão", value: "sale_analysis" },
        { text: "Demora no Fornecimento", value: "supply_delay" },
        { text: "Conta CEMIG retida", value: "retained_account" },
        { text: "Solicitação do jurídico", value: "legal_request" },
        { text: "Contas separadas", value: "separate_accounts" },
        { text: "Todas as UCs canceladas", value: "all_ucs_canceled" },
        { text: "Desistência (7 dias)", value: "gave_up" },
        { text: "Aderiu ao concorrente", value: "competitor" },
      ],
      reason: null,
      serviceId: null,
      reasonDescription: "",
      reasonForcedDescription: "",
      checkbox_free_fine: false,
      freeOldBillings: false,
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
      analysisDialog: false,
      search_referral: "",
      headers_referral: [
        {
          text: "Data de Indicação",
          align: "left",
          sortable: false,
          value: "created_at",
        },
        { text: "E-mail do Indicado", value: "referral_indicated" },
        { text: "Valor Recebido", value: "referral_value_indicator" },
      ],
      limpaNome: {
        dialog: false,
        userId: "",
      },
      canFreeFine: false,
      loadingPermission: false,
    };
  },
  created() {
    this.agent_email = this.user?.email || null;
  },
  filters: {
    toCurrency(value) {
      if (!value) return "";
      return "R$ " + value.toString().replace(".", ",");
    },
    formatStatusNegativation(value) {
      if (!value) return "";
      else if (value === "sent") return "ATIVO";
      else if (value === "removed") return "REMOVIDO";
    },
  },
  methods: {
    ...mapMutations("cs", ["setConsumerUnit", "setFilter"]),
    ...mapActions("cs", [
      "resetFilter",
      "getUserByParams",
      "getReferralsByIndicatorEmail",
    ]),
    ...mapActions("qualification", ["getQualifications"]),

    showForceCanceling() {
      this.dialog_forceCanceling = true;
    },
    showChangeEmail() {
      this.dialog_changeEmail = true;
    },
    showResetPassword() {
      this.dialog_resetPassword = true;
    },
    showActivateUser() {
      this.dialog_activateUser = true;
    },
    showReferral(email) {
      this.dialog_referral = true;
      this.getReferralsByIndicatorEmail(email);
    },

    async checkFreeFinePermission() {
      const permission = await this.hasPermission("change_cancellation_fine");
      this.canFreeFine = permission;
    },

    async multa() {
      const permission = await this.hasPermission("cancel_user");

      if (!permission) {
        this.showSnackBar(
          "Usuário sem permissão para realizar essa ação",
          "top",
          "red",
        );
        this.loadingChange = false;
        return false;
      }

      this.dialog_cancellingUser = true;
      this.checkFreeFinePermission();
      this.valorMulta = 0;
      this.consumer_units_fine = [];
      this.hasFine = false;

      try {
        let fine = await getFine(null, this.userCS.customer_id);

        for (const uc of fine.consumer_units) {
          if (uc.fine) {
            this.consumer_units_fine.push(uc.consumer_unit);
            this.hasFine = true;
            this.valorMulta += uc.amount;
          }
        }
      } catch (err) {
        this.showSnackBar(
          "Erro ao calcular multa, contate o setor de tecnologia.",
          "top",
          "warning",
        );
        console.log(err);
      }
    },

    resetPassword(userCS) {
      firebaseAuth
        .sendPasswordResetEmail(userCS.email)
        .then(() => {
          this.showSnackBar(
            "Email enviado para " + userCS.email,
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.showSnackBar(
            "Erro ao enviar email para " + userCS.email,
            "top",
            "red",
          );
          console.error(err);
        });
      this.dialog_resetPassword = false;
    },
    changeEmail(userCS, new_email) {
      this.loading_changeEmail = true;
      if (
        (userCS.id === "" || new_email.trim() === "") &&
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(new_email)
      ) {
        this.showSnackBar("Por favor, preencha um email válido!", "top", "red");
        this.loading_changeEmail = false;
        return;
      }
      changeEmail(userCS.id, new_email)
        .then(async (res) => {
          if (res.status === 200 && res.data?.code == "success") {
            // console.log('res: ', res)
            this.showSnackBar("Email alterado com sucesso!", "top", "green");
            await this.resetFilter();
            let params = {
              email: new_email,
            };
            await this.setFilter(params);
            await this.getUserByParams(params);
            this.loading_changeEmail = false;
            this.dialog_changeEmail = false;
          } else {
            let mensagem =
              res.status + ": Erro ao alterar email! " + res.data?.message ||
              "";
            if (res.status === 404) {
              mensagem =
                "404: Membro não encontrado! " + res.data?.message || "";
            } else if (res.status === 409) {
              mensagem = "409: Email já cadastrado! " + res.data?.message || "";
            }
            this.loading_changeEmail = false;
            this.showSnackBar(mensagem, "top", "red");
            console.error("Erro ao atualizar email ", res);
          }
        })
        .catch((err) => {
          let mensagem = "Erro ao alterar email! " + err;
          if (err.response?.status) {
            if (err.response.status === 404) {
              mensagem =
                "404: Membro não encontrado! " + err.response.data?.message ||
                "";
            } else if (err.response.status === 409) {
              mensagem =
                "409: Email já cadastrado! " + err.response.data?.message || "";
            }
          }
          console.error(err);
          this.loading_changeEmail = false;
          this.showSnackBar(mensagem, "top", "red");
        });
    },
    async activateUser(userCS) {
      this.loadingChange = true;
      await getObligations(userCS.id)
        .then((billings) => {
          // console.log('billings ->', billings)
          if (billings.length) {
            this.dialog_activateUser = false;
            this.showSnackBar(
              "Não foi possível reativar pois o membro possui pendências financeiras.",
              "top",
              "red",
            );
          } else {
            updateUser(userCS.id, {
              status: "ATIVO",
              last_agent_id: this.user.id,
              last_agent_name: this.user.name,
              last_agent_email: this.user.email,
            })
              .then(() => {
                this.dialog_activateUser = false;
                this.showSnackBar(
                  `Usuário foi reativado com sucesso!`,
                  "top",
                  "green",
                );
              })
              .catch((err) => {
                this.dialog_activateUser = false;
                this.showSnackBar(
                  "Erro ao reativar usuário. Tente novamente mais tarde. " +
                    err,
                  "top",
                  "red",
                );
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.dialog_activateUser = false;
          this.showSnackBar(
            "Erro ao reativar usuário. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
      this.loadingChange = false;
    },

    async cancellingUser() {
      if (!this.$refs["userStatus"].validate()) {
        return false;
      }
      this.loadingChange = true;

      /*
       Se a data de assinatura do contrato do usuário for superior a 7 dias,
       ele não pode ser cancelado com o motivo "Desistência (7 dias)"
      */
      const signedcontract_at = dayjs(this.userCS.signedcontract_at);
      if (
        this.reason === "gave_up" &&
        signedcontract_at.isBefore(dayjs().subtract(7, "day"))
      ) {
        this.showSnackBar(
          "Não é possível cancelar com esse motivo pois o contrato foi assinado há mais de 7 dias.",
          "top",
          "warning",
        );
        return false;
      }

      const allUnitsHaveNoContractTime = this.consumerUnits.every((unit) => {
        return !unit.plan?.contract_time || unit.plan.contract_time === 0;
      });

      if (allUnitsHaveNoContractTime) {
        this.checkbox_free_fine = true;
      }

      await cancelUser({
        user_id: this.userCS.id,
        service_id: this.serviceId,
        reason: this.reason,
        reason_description: this.reasonDescription,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        free_fine: this.checkbox_free_fine,
        check_obligations: true,
      })
        .then(() => {
          this.dialog_cancellingUser = false;
          this.showSnackBar(
            `Usuário foi ${
              this.userCS.status === "ATIVO"
                ? "colocado em processo de cancelamento"
                : "cancelado"
            } com sucesso!`,
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.dialog_cancellingUser = false;
          this.showSnackBar(
            "Erro ao cancelar usuário. " + err.response.data.message,
            "top",
            "red",
          );
        });
      this.loadingChange = false;
    },

    async reactivateUser() {
      this.loadingChange = true;
      await reactivateCustomer({
        user_id: this.userCS.id,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      })
        .then(() => {
          this.reactivateUserDialog = false;
          this.showSnackBar(
            "Usuário colocado em processo de reativação com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.reactivateUserDialog = false;
          this.showSnackBar(
            "Erro ao reativar o usuário. " + err.response.data.message,
            "top",
            "red",
          );
        });
      this.loadingChange = false;
    },

    async ucs_selected(userCS) {
      this.loading_qualification = true;
      const filteredUcs = this.ucs_checkbox?.map(
        (index) => this.consumerUnits[index],
      );

      const ucs = filteredUcs?.map((el) => el.installation_number);

      const utility_companies = filteredUcs?.map((uc) => uc.utility_company);
      const single_utilities = [...new Set(utility_companies)];

      if (single_utilities.length > 1) {
        this.showSnackBar(
          "Selecione apenas Unidades Consumidoras da mesma concessionária.",
          "top",
          "red",
        );
        this.loading_qualification = false;
        return;
      }

      await initQualification(
        userCS.cpf,
        userCS.id,
        ucs,
        "reactivation",
        true,
        null,
        single_utilities[0],
        null,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: userCS.cpf,
              qualification_ids: this.qualification_ids,
            };
            this.getQualifications(params);
          } else {
            this.showSnackBar(
              "Erro ao iniciar qualificação.",
              "top",
              "warning",
            );
          }
        })
        .catch((err) => {
          this.showSnackBar(
            `Erro ao iniciar qualificação. ${
              err && err.response ? err.response.data : ""
            }`,
            "top",
            "warning",
          );
        });
      this.loading_qualification = false;
    },

    async finishQualificationProcess(userCS) {
      await finishQualification(
        userCS.cpf,
        userCS.id,
        this.qualification_ids,
        null,
        null,
        null,
        null,
        null,
        null,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            let results = ret.data.results;
            for (let result in results) {
              let uc_added = !result
                ? false
                : results[result].consumer_unit_added;
              if (!uc_added) {
                let uc_error = {
                  installation_number: results[result].consumer_unit,
                  message:
                    "Erro ao reativar unidade consumidora. " +
                    results[result].message,
                  icon: "mdi-alert-circle",
                };
                this.finish_ucs.push(uc_error);
              } else {
                let uc_success = {
                  installation_number: results[result].consumer_unit,
                  message:
                    "Unidade consumidora colocada em processo de reativação.",
                  icon: "mdi-check",
                };
                this.finish_ucs.push(uc_success);
              }
            }
          } else {
            this.showSnackBar(
              "Erro ao adicionar unidade consumidora! " + ret.data,
              "top",
              "error",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.showSnackBar(
            `Erro ao adicionar unidade consumidora! ${
              err && err.response ? err.response.data : ""
            }`,
            "top",
            "error",
          );
        });
    },

    async forceCancelingUser(userCS) {
      try {
        this.loadingChange = true;
        const permission = await this.hasPermission("forced_cancellation");

        if (!permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      await updateUser(userCS.id, {
        forced_canceling: true,
        reasonForcedDescription: this.reasonForcedDescription,
        abonar_faturas: this.freeOldBillings,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      })
        .then(() => {
          this.dialog_forceCanceling = false;
          this.showSnackBar(
            "Usuário foi colocado em processo de cancelamento forçado com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.dialog_forceCanceling = false;
          this.showSnackBar(
            "Erro ao forçar cancelamento do usuário. Tente novamente mais tarde. " +
              err,
            "top",
            "red",
          );
          console.error(err);
        });
      this.loadingChange = false;
    },
    selectConsumerUnit(uc) {
      this.setConsumerUnit(uc);
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
    async removeNegativations(negativationsActive) {
      try {
        this.loadingChange = true;
        const permission = await this.hasPermission("remove_negativations");

        if (!permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      for (
        let negativationIterator = 0;
        negativationIterator <= negativationsActive.length;
        negativationIterator++
      ) {
        let negativation = negativationsActive[negativationIterator];

        if (negativation.id) {
          let negativationBillingsData = {
            removed_at: new Date(),
            removed_by: this.user.email,
            status: "removed",
            updated_at: new Date(),
          };
          await removeNegativation(negativation, negativationBillingsData)
            .then(async () => {
              this.showSnackBar(
                "Cliente marcado como removido da negativação!",
                "bottom",
                "green",
              );
              this.dialog_removeNegativation = false;
              this.dialog_hasNegativation = false;
              const analytics = {
                eventCategory: "BILLING",
                eventAction: "NEGATIVATION_REMOVED",
                eventLabel: "NEGATIVATION",
                user_id: this.user.email,
                agent: this.user.email,
                competence: negativation.competence,
                consumer_unit: negativation.consumer_unit,
                // power_plant_id: negativation.power_plant_id,
                boleto: false,
              };
              saveAnalytics(analytics);
            })
            .catch((err) => {
              this.negativationDialog = false;
              this.loadingChange = false;
              this.showSnackBar(
                "Erro realizar ao tentar marcar o cliente como removido da negativação!",
                "top",
                "red",
              );
              console.error(err.response.data.error);
            });
        }
      }
    },
    goToMember(id) {
      this.$router.push({ path: "/membro/" + id });
    },
    async changeUserData() {
      try {
        this.loadingChange = true;
        const permission = await this.hasPermission("edit_customer");

        if (!permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (!this.$refs[this.editTarget].validate()) {
        return false;
      }

      // console.log(this.userCS.id, this.editTarget, this.editValue)
      let data;
      if (this.editTarget == "date_of_birth")
        data = { [this.editTarget]: new Date(this.editValue) };
      else if (this.editTarget == "phone")
        data = { [this.editTarget]: "+" + this.editValue };
      else
        data = {
          [this.editTarget]: this.editValue,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
        };
      updateUser(this.userCS.id, data)
        .then(() => {
          this.editDialog = false;
          this.editTarget = "";
          this.editValue = "";
          this.loadingChange = false;
          this.showSnackBar("Campo alterado com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.editDialog = false;
          this.editTarget = "";
          this.editValue = "";
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar campo. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
    },
    async changeCredentials() {
      try {
        this.loadingChange = true;
        const permission = await this.hasPermission("edit_cpf_cnpj");

        if (!permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (!this.$refs[this.editTarget].validate()) {
        return false;
      }

      try {
        const data = {
          [this.editTarget]: this.editValue,
        };
        await updateUserCore(this.userCS.id, data);
        this.editCredentials = false;
        this.editTarget = "";
        this.editValue = "";
        this.loadingChange = false;
        this.showSnackBar("Campo alterado com sucesso!", "top", "green");
      } catch (err) {
        this.editCredentials = false;
        this.editTarget = "";
        this.editValue = "";
        this.loadingChange = false;
        this.showSnackBar(
          "Erro ao alterar campo. Tente novamente mais tarde. " + err,
          "top",
          "red",
        );
      }
    },
    async putInAnalysis(user) {
      this.loadingChange = true;
      await updateUser(user.id, {
        underAnalysis: true,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        analysis_agent: this.user.email,
        start_analysis_at: new Date(),
      })
        .then(() => {
          this.analysisDialog = false;
          this.showSnackBar("Usuário foi colocado em análise!", "top", "green");
        })
        .catch((err) => {
          this.analysisDialog = false;
          this.showSnackBar(
            "Erro ao colocar o usuário em análise. Tente novamente mais tarde. " +
              err,
            "top",
            "red",
          );
          console.error(err);
        });
      this.loadingChange = false;
    },
    async removeFromAnalysis(user) {
      this.loadingChange = true;
      await updateUser(user.id, {
        underAnalysis: false,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        finish_analysis_at: new Date(),
      })
        .then(() => {
          this.analysisDialog = false;
          this.showSnackBar("Usuário foi retirado da análise!", "top", "green");
        })
        .catch((err) => {
          this.analysisDialog = false;
          this.showSnackBar(
            "Erro ao retirar o usuário da análise. Tente novamente mais tarde. " +
              err,
            "top",
            "red",
          );
          console.error(err);
        });
      this.loadingChange = false;
    },
    openLimpaNomeDialog(userId) {
      this.limpaNome.dialog = true;
      this.limpaNome.userId = userId;
    },
    async removeLimpaNome(userId) {
      this.loadingChange = true;
      await updateUser(userId, {
        limpa_nome: false,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        remove_limpa_nome_agent: this.user.email,
      })
        .then(() => {
          this.limpaNome.dialog = false;
          this.showSnackBar("Limpa nome removido com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.limpaNome.dialog = false;
          this.showSnackBar(
            "Erro ao remover fatura do limpa nome",
            "top",
            "red",
          );
          console.error(err);
        });
      this.loadingChange = false;
    },
  },
};
</script>

<style>
.custom-cursor {
  pointer-events: none;
}
</style>
